<acabim-card cardHeading="Add BIM Model"
             [isCollapsible]="true" [isCollapsed]="false"
             [cardContent]="cardContent"
             [hasHelpButton]="true"
             [helpMessage]="'Select the model type, specify the project phase, and upload an IFC file against the selected project.'"
             *ngIf="(projectApiService.selectedProjectId$ | async); else noProject">

</acabim-card>

<ng-template #cardContent>
    <ng-container [ngSwitch]="currentState">
        <form [formGroup]="createBimModelForm" *ngSwitchDefault class="p-d-flex p-flex-row p-flex-wrap">
            <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" [shortFields]="true" class="col-md-6">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Model Type</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-dropdown
                                id="bim-model-type"
                                inputId="bim-model-type"
                                [options]="currentModelTypes"
                                formControlName="modelType"
                                optionLabel="name"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Model Phase</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-dropdown
                                id="bim-model-phase"
                                inputId="bim-model-phase"
                                [options]="currentBimPhases" formControlName="modelPhase"
                                optionLabel="name"
                                (onChange)="refreshDateValidators()"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Model Name</acabim-form-input-label>
                    <acabim-form-input-content>
                        <input id="modelName" type="text" pInputText formControlName="modelName">
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
            <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" [shortFields]="true" class="col-md-6">
                <acabim-form-input-wrapper *ngIf="isPostConstructionPhase">
                    <acabim-form-input-label>Practical Completion Date</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-calendar
                                id="completionDate"
                                formControlName="completionDate"
                                dateFormat="D dd MM yy"
                                #calendar
                                [readonlyInput]="true"
                                [yearNavigator]="true"
                                [yearRange]="validYearRange"
                                [monthNavigator]="true"></p-calendar>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper *ngIf="isConstructionPhase">
                    <acabim-form-input-label>Construction Start Date</acabim-form-input-label>
                    <acabim-form-input-content>
                        <p-calendar
                                id="constructionDate"
                                formControlName="constructionDate"
                                dateFormat="D dd MM yy"
                                #calendar
                                [readonlyInput]="true"
                                [yearNavigator]="true"
                                [yearRange]="validYearRange"
                                [monthNavigator]="true"></p-calendar>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
            <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" [shortFields]="true" class="col-md-12">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>IFC</acabim-form-input-label>
                    <acabim-form-input-content>
                        <acabim-file-upload #ifcFileUpload class="p-field" [type]="'.ifc'"></acabim-file-upload>
                        <ng-container *ngIf="ifcFileUpload.fileName">
                            <div>{{ifcFileUpload.fileName}}</div>
                            <div><button (click)="ifcFileUpload.resetFile()" class="cas-button-action">Reset</button></div>
                        </ng-container>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>

            <div class="cas-action-buttons">
                <button (click)='addModel()' class="cas-button-action mt-3">Add Model</button>
            </div>
        </form>

        <div class="p-5" *ngSwitchCase="1">
            <h6>Uploading file</h6>
            <p-progressBar [value]="currentUploadProgress"></p-progressBar>
        </div>

        <div class="p-5" *ngSwitchCase="2">
            <h6>Processing file</h6>
            <p-progressBar mode="indeterminate"></p-progressBar>
        </div>
    </ng-container>
</ng-template>

<ng-template #noProject>
    <div class="cas-error">Please select a project to manage its models</div>
</ng-template>

<p-toast position="top-right"></p-toast>
